import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const SEND_EMAIL = USER_ROOT_API_URL +  "/send_email"
